import React from "react";
import List from "./List";
import "./tab-timer.scss";

export default function(props) {
  return <List {...props} />;
}
